import {
    MEMBER_BLACKLIST_ADD_SUCCESS,
    MEMBER_BLACKLIST_DELETE_SUCCESS
} from 'reducers/member';

const GET_MEMBER_BLACKLIST_REQUEST = 'GET_MEMBER_BLACKLIST_REQUEST';
const GET_MEMBER_BLACKLIST_SUCCESS = 'GET_MEMBER_BLACKLIST_SUCCESS';
const GET_MEMBER_BLACKLIST_FAILURE = 'GET_MEMBER_BLACKLIST_FAILURE';

const initState = {
    list: null,
    totalCount: 0
};

import * as backend from 'backend-helpers/memberBlackList';

export default function memberBlackList(state = initState, action) {
    if (action.type === GET_MEMBER_BLACKLIST_SUCCESS) {
        let {list, totalCount} = action.result.data.blacklist;

        return {
            ...state,
            list,
            totalCount
        }
    }

    if (action.type === MEMBER_BLACKLIST_ADD_SUCCESS) {
        let {list} = state;
        let objectExists = false;
        let {new_item} = action.result;

        for (let key in list) {
            if(list[key].target_user.id === new_item.target_user.id) objectExists = true;
        }

        if (state.list && new_item && !objectExists) {
            return {
                ...state,
                list: [...state.list, new_item],
                totalCount: state.totalCount + 1
            }
        }
    }

    if (action.type === MEMBER_BLACKLIST_DELETE_SUCCESS) {
        if (state.list) {
            let newList = state.list.filter((user) => user.target_user.id !== action.id);
            if (newList.length !== state.list.length) {
                return {
                    ...state,
                    list: newList,
                    totalCount: state.totalCount - 1
                }
            }
        }
    }

    return state;
}

export function getMemberBlackList(data) {
    return {
        types: [GET_MEMBER_BLACKLIST_REQUEST, GET_MEMBER_BLACKLIST_SUCCESS, GET_MEMBER_BLACKLIST_FAILURE],
        promise: backend.getMemberBlackList(data),
        data
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberBlackList.js